import Swal from 'sweetalert2'
import 'sweetalert2/src/sweetalert2.scss'

export default defineNuxtPlugin({
  name: 'Global',
  setup (nuxtApp) {
    function log(...args) {
      console.log('DEBUG', args)
    }

    function alert(message?:string | HTMLElement){
      return Swal.fire({
        icon: 'warning',
        html: message,
        customClass: {
          confirmButton: 'bg-gradient-to-r from-primary-500 via-primary-700 to-primary-900 sliding-gradient !text-white sliding-gradient rounded-[6px]',          
        }
      })
    }

    function confirm(message:string | HTMLElement, confirmText?:string, cancelText?:string){
      if( ! confirmText){
        confirmText = "Confirm";
      }
      if( ! cancelText){
        cancelText = "";
      }
      return Swal.fire({
        title: "",
        html: message,
        icon: 'warning',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: confirmText,
        cancelButtonText: cancelText,
        customClass: {
          confirmButton: 'bg-gradient-to-r from-primary-500 via-primary-700 to-primary-900 sliding-gradient !text-white sliding-gradient rounded-[6px]',
          cancelButton: 'relative gradient-border',
        },
        didRender: () => {
            const cancelButton = document.querySelector('.swal2-cancel');
            if (cancelButton) {
            cancelButton.setAttribute('data', 'Cancel');
            }
        }
      })
    }

    function error(message:string | HTMLElement){
      return Swal.fire({
        icon: 'error',
        html: message,
        customClass: {
          confirmButton: 'bg-gradient-to-r from-primary-500 via-primary-700 to-primary-900 sliding-gradient !text-white rounded-lg',
        }
      })
    }

    function warning(title:string | HTMLElement, message:string | HTMLElement){
      return Swal.fire({
        title: title,
        icon: 'warning',
        html: message,
        customClass: {
          confirmButton: 'bg-gradient-to-r from-primary-500 via-primary-700 to-primary-900 sliding-gradient !text-white sliding-gradient rounded-[6px]',          
        }
      })
    }

    function success(message:string | HTMLElement){
      return Swal.fire({
        icon: 'success',
        html: message,
        customClass: {
          confirmButton: 'bg-gradient-to-r from-primary-500 via-primary-700 to-primary-900 sliding-gradient !text-white sliding-gradient rounded-[6px]',          
        }
      })
    }

    return {
      provide: {
        Global: {
          Swal,
          alert,
          confirm,
          error,
          log,
          success,
          warning,
        }
      }
    }
  } 
});